import React, { useCallback } from 'react';
import { Button, Container } from 'react-bootstrap';

import '../styles/PageNav.css';
import { array, func, number } from 'prop-types';
import PageNavButtons from './PageNavButtons';

export default function PageNav({ curPage, totalPages, generatedPagesData, paginateUser = () => { } }) {
    const onPageClick = useCallback((page) => () => paginateUser(page), []);

    return (<>
        {(totalPages > 0 && generatedPagesData) && (
            <div
                className={'d-flex align-items-center gap-2'}>
                Pages:
                <Container
                    className={'page--list-nav'}>
                    {generatedPagesData.map((page) => (
                        <Button
                            aria-label={'Go to page ' + page.displayPage}
                            key={'page-' + page.page}
                            onClick={onPageClick(page.page + 1)}
                            className={'page--list-btn-number'}
                            disabled={curPage === page.page + 1}>{page.displayPage}
                        </Button>
                    ))}
                    <PageNavButtons
                        curPage={curPage}
                        totalPages={totalPages}
                        paginateUser={paginateUser}
                    />
                </Container>
            </div>
        )}
    </>);
}

PageNav.propTypes = {
    curPage: number,
    totalPages: number,
    generatedPagesData: array,
    paginateUser: func,
};